import {AdminEmployeeLayout} from "./pages/admin/employee/layout";
import {Route} from "react-router-dom";
import {AdminEmployeePage} from "./pages/admin/employee";
import {PersonDocumentListPage} from "./pages/admin/employee/person/document";
import {PayrollListPage} from "./pages/admin/employee/payroll";
import {PayrollEditPage} from "./pages/admin/employee/payroll/form";
import {PayrollPackListPage} from "./pages/admin/employee/payrollpack";
import {PayrollPackEditPage} from "./pages/admin/employee/payrollpack/form";
import {HolidayListPage} from "./pages/admin/employee/holiday";
import {HolidayEditPage} from "./pages/admin/employee/holiday/form";
import {VacationsListPage} from "./pages/admin/employee/vacations";
import {VacationEditPage} from "./pages/admin/employee/vacations/form";
import {PersonListPage} from "./pages/admin/employee/person";
import {PersonEditPage} from "./pages/admin/employee/person/form";
import {SalaryListPage} from "./pages/admin/employee/person/salary";
import {SalaryEditPage} from "./pages/admin/employee/person/salary/form";
import {RateAuditPage} from "./pages/admin/employee/rateaudit";
import {PersonDocumentEditPage} from "./pages/admin/employee/person/document/form";
import {PersonEventListPage} from "./pages/admin/employee/person/event";
import {PersonEventEditPage} from "./pages/admin/employee/person/event/form";
import {EvaluationListPage} from "./pages/admin/employee/evaluation";
import {EvaluationEditPage} from "./pages/admin/employee/evaluation/form";
import {InterviewListPage} from "./pages/admin/employee/interview";
import {InterviewEditPage} from "./pages/admin/employee/interview/form";
import {WikiPageListPage} from "./pages/admin/employee/wiki";
import {SECTION_HR, WikiPageEditPage} from "./pages/admin/employee/wiki/form";
import {EvaluationPointListPage} from "./pages/admin/employee/evaluationpoint";
import {TrainingRecordListPage} from "./pages/admin/employee/training";
import {TrainingRecordEditPage} from "./pages/admin/employee/training/form";
import {EvaluationPointEditPage} from "./pages/admin/employee/evaluationpoint/form";
import {EvaluationResultListPage} from "./pages/admin/employee/evaluationresult";
import {EvaluationResultEditPage} from "./pages/admin/employee/evaluationresult/form";
import {PersonDocumentTypeListPage} from "./pages/admin/employee/persondoctype";
import {PersonDocumentTypeEditPage} from "./pages/admin/employee/persondoctype/form";
import {PersonReminderListPage} from "./pages/admin/employee/reminder";
import {PersonReminderEditPage} from "./pages/admin/employee/reminder/form";
import {WorkCenterListPage} from "./pages/admin/employee/workcenter";
import {WorkCenterEditPage} from "./pages/admin/employee/workcenter/form";
import {WorkBookingListPage} from "./pages/admin/employee/workbooking";
import {WorkBookingEditPage} from "./pages/admin/employee/workbooking/form";
import * as React from "react";
import SideBarItem from "./sidebar_item";
import {
	AccountTree,
	AllInbox,
	AssignmentInd,
	BeachAccess,
	Description,
	Inbox,
	NoteAlt,
	PersonSearch,
	WorkOff
} from "@mui/icons-material";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import StyleIcon from "@mui/icons-material/Style";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import {SupportEditPage} from "./pages/admin/compliance/support/form";
import {SupportListPage} from "./pages/admin/compliance/support";
import SchoolIcon from "@mui/icons-material/School";
import {OrganizationUnitListPage} from "./pages/admin/employee/organizationunit";
import {OrganizationUnitEditPage} from "./pages/admin/employee/organizationunit/form";
import {UnitMemberEditPage} from "./pages/admin/employee/person/member/form";
import {UnitMemberListPage} from "./pages/admin/employee/person/member";
import {TimeClockAdminPage} from "./pages/admin/employee/timeclock";
import {DedicationAuditPage} from "./pages/admin/employee/dedication_audit";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import ScheduleIcon from "@mui/icons-material/Schedule";


const AdminEmployeeRoutes = () => {
	return (
		<Route path="/app/admin/employee" element={<AdminEmployeeLayout/>}>
			<Route index element={<AdminEmployeePage/>}/>
			<Route path="/app/admin/employee/timeclock" element={<TimeClockAdminPage/>}/>
			<Route path="/app/admin/employee/dedication-audit" element={<DedicationAuditPage/>}/>
			<Route path="/app/admin/employee/persondoc"
				   element={<PersonDocumentListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/interview"
				   element={<InterviewListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/interview/:id"
				   element={<InterviewEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/interview/new"
				   element={<InterviewEditPage/>}/>
			<Route path="/app/admin/employee/interview"
				   element={<InterviewListPage/>}/>
			<Route path="/app/admin/employee/interview/:id"
				   element={<InterviewEditPage/>}/>
			<Route path="/app/admin/employee/interview/new"
				   element={<InterviewEditPage/>}/>
			<Route path="/app/admin/employee/payroll" element={<PayrollListPage/>}/>
			<Route path="/app/admin/employee/payroll/:id" element={<PayrollEditPage/>}/>
			<Route path="/app/admin/employee/payroll/new" element={<PayrollEditPage/>}/>
			<Route path="/app/admin/employee/payrollpack"
				   element={<PayrollPackListPage/>}/>
			<Route path="/app/admin/employee/payrollpack/:id"
				   element={<PayrollPackEditPage/>}/>
			<Route path="/app/admin/employee/payrollpack/new"
				   element={<PayrollPackEditPage/>}/>
			<Route path="/app/admin/employee/holiday" element={<HolidayListPage/>}/>
			<Route path="/app/admin/employee/holiday/:id" element={<HolidayEditPage/>}/>
			<Route path="/app/admin/employee/holiday/new" element={<HolidayEditPage/>}/>
			<Route path="/app/admin/employee/organizationunit" element={<OrganizationUnitListPage/>}/>
			<Route path="/app/admin/employee/organizationunit/:id" element={<OrganizationUnitEditPage/>}/>
			<Route path="/app/admin/employee/organizationunit/new" element={<OrganizationUnitEditPage/>}/>
			<Route path="/app/admin/employee/vacations" element={<VacationsListPage/>}/>
			<Route path="/app/admin/employee/vacations/:id"
				   element={<VacationEditPage/>}/>
			<Route path="/app/admin/employee/vacations/new"
				   element={<VacationEditPage/>}/>
			<Route path="/app/admin/employee/rateaudit" element={<RateAuditPage/>}/>
			<Route path="/app/admin/employee/person" element={<PersonListPage/>}/>
			<Route path="/app/admin/employee/person/new" element={<PersonEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId"
				   element={<PersonEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/salary"
				   element={<SalaryListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/salary/:id"
				   element={<SalaryEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/salary/new"
				   element={<SalaryEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/organization-unit"
				   element={<UnitMemberListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/organization-unit/:id"
				   element={<UnitMemberEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/organization-unit/new"
				   element={<UnitMemberEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/document"
				   element={<PersonDocumentListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/document/:id"
				   element={<PersonDocumentEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/document/new"
				   element={<PersonDocumentEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/event"
				   element={<PersonEventListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/event/:id"
				   element={<PersonEventEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/event/new"
				   element={<PersonEventEditPage/>}/>
			<Route path="/app/admin/employee/wiki"
				   element={<WikiPageListPage section={SECTION_HR}/>}/>
			<Route path="/app/admin/employee/wiki/:id"
				   element={<WikiPageEditPage section={SECTION_HR}/>}/>
			<Route path="/app/admin/employee/wiki/new"
				   element={<WikiPageEditPage section={SECTION_HR}/>}/>
			<Route path="/app/admin/employee/person/:personId/evaluation"
				   element={<EvaluationListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/evaluation/:id"
				   element={<EvaluationEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/evaluation/new"
				   element={<EvaluationEditPage/>}/>
			<Route path="/app/admin/employee/evaluation"
				   element={<EvaluationListPage/>}/>
			<Route path="/app/admin/employee/evaluation/:id"
				   element={<EvaluationEditPage/>}/>
			<Route path="/app/admin/employee/evaluation/new"
				   element={<EvaluationEditPage/>}/>
			<Route path="/app/admin/employee/training"
				   element={<TrainingRecordListPage/>}/>
			<Route path="/app/admin/employee/training/:id"
				   element={<TrainingRecordEditPage/>}/>
			<Route path="/app/admin/employee/training/new"
				   element={<TrainingRecordEditPage/>}/>
			<Route path="/app/admin/employee/evaluationpoint"
				   element={<EvaluationPointListPage/>}/>
			<Route path="/app/admin/employee/evaluationpoint/:id"
				   element={<EvaluationPointEditPage/>}/>
			<Route path="/app/admin/employee/evaluationpoint/new"
				   element={<EvaluationPointEditPage/>}/>
			<Route path="/app/admin/employee/evaluationresult"
				   element={<EvaluationResultListPage/>}/>
			<Route path="/app/admin/employee/evaluationresult/:id"
				   element={<EvaluationResultEditPage/>}/>
			<Route path="/app/admin/employee/evaluationresult/new"
				   element={<EvaluationResultEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/support"
				   element={<SupportListPage/>}/>
			<Route path="/app/admin/employee/person/:personId/support/:id"
				   element={<SupportEditPage/>}/>
			<Route path="/app/admin/employee/person/:personId/support/new"
				   element={<SupportEditPage/>}/>
			<Route path="/app/admin/employee/persondoctype"
				   element={<PersonDocumentTypeListPage/>}/>
			<Route path="/app/admin/employee/persondoctype/:id"
				   element={<PersonDocumentTypeEditPage/>}/>
			<Route path="/app/admin/employee/persondoctype/new"
				   element={<PersonDocumentTypeEditPage/>}/>
			<Route path="/app/admin/employee/reminder"
				   element={<PersonReminderListPage/>}/>
			<Route path="/app/admin/employee/reminder/:id"
				   element={<PersonReminderEditPage/>}/>
			<Route path="/app/admin/employee/reminder/new"
				   element={<PersonReminderEditPage/>}/>
			<Route path="/app/admin/employee/workcenter"
				   element={<WorkCenterListPage/>}/>
			<Route path="/app/admin/employee/workcenter/:id"
				   element={<WorkCenterEditPage/>}/>
			<Route path="/app/admin/employee/workcenter/new"
				   element={<WorkCenterEditPage/>}/>
			<Route path="/app/admin/employee/workbooking"
				   element={<WorkBookingListPage/>}/>
			<Route path="/app/admin/employee/workbooking/:id"
				   element={<WorkBookingEditPage/>}/>
			<Route path="/app/admin/employee/workbooking/new"
				   element={<WorkBookingEditPage/>}/>
		</Route>
	);
}

export default AdminEmployeeRoutes;

export const AdminEmployeeMenu = () => {
	return (
		<>
			<SideBarItem
				href={"/app/admin/employee/person"}
				label={"Personal"}
				icon={<AssignmentInd/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/timeclock"}
				label={"Registro de jornada"}
				icon={<ScheduleIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/dedication-audit"}
				label={"Dedicación"}
				icon={<QueryStatsIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/vacations"}
				label={"Ausencias"}
				icon={<BeachAccess/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/persondoc"}
				label={"Documentos del personal"}
				icon={<Description/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/payrollpack"}
				label={"Pack de Nóminas"}
				icon={<AllInbox/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/payroll"}
				label={"Nóminas"}
				icon={<Inbox/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/interview"}
				label={"Entrevistas"}
				icon={<PersonSearch/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/evaluation"}
				label={"Evaluaciones"}
				icon={<ContentPasteIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/training"}
				label={"Formación"}
				icon={<SchoolIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/organizationunit"}
				label={"Unidades Organizativas"}
				icon={<AccountTree/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/evaluationpoint"}
				label={"Preguntas de Evaluación"}
				icon={<HelpCenterIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/evaluationresult"}
				label={"Respuestas de Evaluación"}
				icon={<FactCheckIcon/>}
			/>
			{/* Los documentos de empresa están en compliance (#13899); RR. HH. los sigue abriendo */}
			<SideBarItem
				href={"/app/admin/compliance/document"}
				label={"Documentos de empresa (en compliance)"}
				icon={<Description/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/persondoctype"}
				label={"Tipos de Documento"}
				icon={<BookmarksIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/reminder"}
				label={"Recordatorios"}
				icon={<NotificationsActiveIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/workbooking"}
				label={"Reservas de Plazas"}
				icon={<StyleIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/workcenter"}
				label={"Centros de Trabajo"}
				icon={<CorporateFareIcon/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/holiday"}
				label={"Festivos"}
				icon={<WorkOff/>}
			/>
			<SideBarItem
				href={"/app/admin/employee/wiki"}
				label={"Wiki"}
				icon={<NoteAlt/>}
			/>
		</>
	)
}